export const overviewExportConfig = {
  page: { key: 'overview', title: 'Overview Dashboard' },
  sections: [
    { key: 'base', title: '' },
    {
      key: 'overview-audience-metrics',
      title: 'Audience Metrics',
      order: [],
    },
    {
      key: 'overview-spi-widget',
      title: 'SPI',
      order: [],
    },
    {
      key: 'overview-sub-opportunities',
      title: 'Improvement Opportunities',
      order: [],
    },
    {
      key: 'overview-dimension-tables',
      title: 'Dimension Panels',
      order: [],
    },
  ],
};
